import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { BsPlusCircleFill } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBin5Line, RiGalleryUploadLine } from "react-icons/ri";
import { LiaEyeSlashSolid, LiaEyeSolid } from "react-icons/lia";
import { ImUpload2 } from "react-icons/im";
import { RiUploadCloud2Fill } from "react-icons/ri";

import { GoUpload } from "react-icons/go";


interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
}

interface NewsStructure {
  id:string;
  title:string;
  img:string;
  desc:string;
  date:string;
  PresentMember:string;
}

interface PresentMemb{
  id:number;
  status:string;
}

const Attendance = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const [newData, setNewData] = useState<NewsStructure[]>([]);
      const [userData, setUserData] = useState<UserStructure[]>([]);
      const[preMeb, setPreMeb] = useState<PresentMemb[]>([]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get<NewsStructure[]>(
              `${api}/auth/news`
            );
    
            //console.log('news data',response.data)
            setNewData(response.data);
            //console.log("news data in a array",newData);
          } catch (error) {
            console.error("Post Not Found:", error);
          }
        };
    
        fetchData();
      }, []);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get<UserStructure[]>(
              `${api}/auth/allusersinfo`
            );
    
            //console.log("news data", response.data);
            setUserData(response.data);

            //console.log("user data in a array", newData);
          } catch (error) {
            console.error("user Not Found:", error);
          }
        };
    
        fetchData();
      }, []);
    
  return (
   <div>
   
         <div>
           <div className="px-2 py-3">
   <div className="overflow-x-auto relative">
  <table className="table-auto w-full border-collapse border bg-white border-gray-300">
    <thead className="bg-darkblue text-slate-50">
      <tr>
        <th
          className="sticky left-0 bg-darkblue z-0 border-y border-y-gray-300 px-4 py-2 text-left max-w-[243px] min-w-[243px] text-sm"
        >
          Name
        </th>
        {newData.map((items, index) => (
          <th
            key={index}
            className="border border-gray-300 px-4 py-2 text-left text-sm"
          >
            {items.date.split('T')[0]}
          </th>
        ))}
       
      </tr>
    </thead>
    <tbody>
      {userData.length > 0 ? (
        userData.filter((items)=>items.role!=='super-admin').map((item) => (
          <tr key={item.id} className="border border-gray-300 border-collapse">
            <td
              className="sticky left-0 bg-white z-0 px-4 py-2 flex gap-3 border-r border-gray-300"
            >
              <img
                className="h-[30px] object-cover w-[30px] rounded-full"
                src={
                  item.profile
                    ? item.profile.startsWith("http")
                      ? item.profile
                      : `${api}/${item.profile}`
                    : "https://via.placeholder.com/150"
                }
                alt={item.name || "Image"}
              />
              <div>
                <h3 className="font-semibold text-sm">{item.name}</h3>
                <h3 className="font-normal text-[9px] text-gray-500">
                  {item.designation}
                </h3>
              </div>
            </td>

            {newData.map((items, index) => {
              // const premebArray = JSON.parse(items.PresentMember);
              const premebArray = items.PresentMember 
    ? JSON.parse(items.PresentMember) 
    : [];
              const matchedMember = premebArray.find(
                (pid:any) => pid.id === item.id
              );

              return (
                <td
                  key={index}
                  className="border-y border-y-gray-300 px-4 py-2 capitalize border border-gray-300"
                >
                  {matchedMember ? (
                    <span
                      className={`w-[90px] block px-3 py-2 text-sm text-center font-medium text-white ${
                        matchedMember.status === "present"
                          ? "bg-green-600"
                          : matchedMember.status === "substitute"
                          ? "bg-darkblue"
                          : matchedMember.status === "late"
                          ? "bg-yellow-500"
                          : matchedMember.status === "leave"
                          ? "bg-[#ff642c]"
                          : matchedMember.status === "N/R"
                          ? "bg-[#1B4242]"
                          : "bg-red-600"
                      }`}
                    >
                      {matchedMember.status || "N/R"}
                    </span>
                  ) : (
                    <span className="text-gray-500 italic">No Match</span>
                  )}
                </td>
              );
            })}
            
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="text-center py-4">
            Loading...
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

   </div>
         </div>
       </div>
  )
}
export default Attendance